import Loadable from '../../components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const ParcelTypeList = Loadable(lazy(() => import('./ParcelTypeList')));
const ParcelTypeDetails = Loadable(lazy(() => import('./ParcelTypeDetails')));

const parcelTypeRoutes = [
	{ path: '/parcel-type', element: <ParcelTypeList />, auth: authRoles.staff },
	{ path: '/parcel-type/:id', element: <ParcelTypeDetails />, auth: authRoles.staff },
];

export default parcelTypeRoutes;